import templatePreview from "../../assets/times.png";
let timesImg = window.wpmNotificationPluginBuildUrl + templatePreview;
const downloadId = "602";

const times = [
  {
    id: "times_wp-signup-admin",
    image: timesImg,
    label: "Times",
    category: "wp-signup-admin",
    downloadId,
  },
  {
    id: "times_wp-signup-user",
    image: timesImg,
    label: "Times",
    category: "wp-signup-user",
    downloadId,
  },
  {
    id: "times_wp-lost-password-admin",
    image: timesImg,
    label: "Times",
    category: "wp-lost-password-admin",
    downloadId,
  },
  {
    id: "times_wp-lost-password-user",
    image: timesImg,
    label: "Times",
    category: "wp-lost-password-user",
    downloadId,
  },
  {
    id: "times_wp-password-changed-user",
    image: timesImg,
    label: "Times",
    category: "wp-password-changed-user",
    downloadId,
  },
  {
    id: "times_wp-change-user-email-user",
    image: timesImg,
    label: "Times",
    category: "wp-change-user-email-user",
    downloadId,
  },
  {
    id: "times_wp-changed-user-email-user",
    image: timesImg,
    label: "Times",
    category: "wp-changed-user-email-user",
    downloadId,
  },
  {
    id: "times_wp-comment-in-moderation-admin",
    image: timesImg,
    label: "Times",
    category: "wp-comment-in-moderation-admin",
    downloadId,
  },
  {
    id: "times_wp-comment-published-post-author",
    image: timesImg,
    label: "Times",
    category: "wp-comment-published-post-author",
    downloadId,
  },
  {
    id: "times_wp-change-site-admin-email",
    image: timesImg,
    label: "Times",
    category: "wp-change-site-admin-email",
    downloadId,
  },
  {
    id: "times_wp-changed-site-admin-email",
    image: timesImg,
    label: "Times",
    category: "wp-changed-site-admin-email",
    downloadId,
  },
  {
    id: "times_wp-request-personal-data-user",
    image: timesImg,
    label: "Times",
    category: "wp-request-personal-data-user",
    downloadId,
  },
  {
    id: "times_wp-confirmed-personal-data-request-admin",
    image: timesImg,
    label: "Times",
    category: "wp-confirmed-personal-data-request-admin",
    downloadId,
  },
  {
    id: "times_wp-download-personal-data-user",
    image: timesImg,
    label: "Times",
    category: "wp-download-personal-data-user",
    downloadId,
  },
  {
    id: "times_wp-erased-personal-data-user",
    image: timesImg,
    label: "Times",
    category: "wp-erased-personal-data-user",
    downloadId,
  },
];

export default times;
